import { render, staticRenderFns } from "./TutorSkuInList.vue?vue&type=template&id=86599630&scoped=true&"
import script from "./TutorSkuInList.vue?vue&type=script&lang=js&"
export * from "./TutorSkuInList.vue?vue&type=script&lang=js&"
import style0 from "./TutorSkuInList.vue?vue&type=style&index=0&id=86599630&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86599630",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VIcon,VSimpleTable})
